// extracted by mini-css-extract-plugin
module.exports = {"purchase_container":"Purchase_purchase_container__p1BRe"};